import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MatSlider, MatSliderRangeThumb } from '@angular/material/slider';

import { TranslateModule } from '@ngx-translate/core';

import { OVERLAY_PANEL_DATA } from 'src/app/core/services/overlay-panel';
import { OverlayPanelRef } from 'src/app/core/services/overlay-panel/overlay-panel-ref';

@Component({
  selector: 'app-hotel-price-range-panel',
  imports: [
    MatSliderRangeThumb,
    MatSlider,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './hotel-price-range-panel.component.html',
  styleUrl: './hotel-price-range-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelPriceRangePanelComponent implements OnChanges {
  @Input() useAsComponent: boolean = false;
  @Input() min: number = 200;
  @Input() max: number = 400;
  @Input() visibleMin = 1;
  @Input() visibleMax = 1000;
  @Output() onApply = new EventEmitter<{ min: number; max: number }>();
  minCtrl = new FormControl(200);
  maxCtrl = new FormControl(400);

  #overlayPanelRef = inject(OverlayPanelRef, { optional: true });
  #data: { min: number; max: number } = inject(OVERLAY_PANEL_DATA, {
    optional: true,
  });

  constructor() {
    if (this.#data) {
      const { min, max } = this.#data;
      this.visibleMin = min;
      this.visibleMax = max;
      this.minCtrl.setValue(min);
      this.maxCtrl.setValue(max);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.min.currentValue) {
        this.minCtrl.setValue(this.min);
      }
      if (changes.max.currentValue) {
        this.maxCtrl.setValue(this.max);
      }
    }
  }

  public applyValues() {
    const values = {
      min: this.minCtrl.value,
      max: this.maxCtrl.value,
    };

    if (this.#overlayPanelRef) {
      this.#overlayPanelRef.emitValue(values);
      this.#overlayPanelRef.close();
    } else {
      this.onApply.emit(values);
    }
  }
}
